import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import style from './ParentalSettings.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import URL from '../../../../constants/url';
import Modal from '../../../../components/comm/Modal';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

const ParentalSettings = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const newParental = location.state;
    const { hsptlCd = '' } = location.state || {};
    //const [parentalList, setParentalList] = useState([]);
    const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(false);    // 삭제 모달창
    const [famlyList, setFamlyList] = useState([]);
    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    
    // useEffect(() => {
    // 브라우저의 뒤로가기로 들어왔을 때 처리
    
    // const handlePopState = () => {
    //     if (location.state?.fromRegister) {
    //         navigate(URL.HOSPITAL_HOME, { replace: true });
    //     }
    //     };

    //     window.addEventListener("popstate", handlePopState);
    //     return () => {
    //     window.removeEventListener("popstate", handlePopState);
    //     };
    // }, [location.state, navigate]);

    useEffect(()=>{

        getFamlyList();

    }, [])


    const getFamlyList = useCallback(async () => {

        const url = "/hsptl/retrieveHsptlFamlyInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
        }

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result;
                setFamlyList(mediInfo.usrFamlyMngList);
            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })


    }, []);


    const saveFamly = useCallback(async (id) => {

        const url = "/hsptl/deleteHsptlFamlyInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            id : id ,
            usrInfoId : user.usrInfoId
        }

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result;
                setFamlyList(mediInfo.usrFamlyMngList);
            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })


    }, []);



    const handleBack = () => {
        navigate(URL.HOSPITAL_HOME, { replace: true });        
    };


    //로컬스토리지 불러오기
    //useEffect(() => {
    //const stored = JSON.parse(localStorage.getItem('parentalList')) || [];
    //setParentalList(stored);
    //}, []);

    // 리스트에 추가
    // useEffect(() => {
    //     if (
    //         newParental &&
    //         typeof newParental === 'object' &&
    //         newParental.name &&
    //         newParental.relation &&
    //         newParental.phone
    //     ) {
    //     setParentalList((prevList) => {
    //     const isDuplicate = prevList.some(
    //         (item) =>
    //         item.name === newParental.name &&
    //         item.relation === newParental.relation &&
    //         item.phone === newParental.phone
    //     );
    //     if (isDuplicate) return prevList;

    //     const updatedList = [newParental, ...prevList];
    //     localStorage.setItem('parentalList', JSON.stringify(updatedList));
    //     return updatedList;
    //     });
    //   }
    // }, [newParental]);

    //항목 삭제 
    const confirmDelete = () => {
        if (selectedDeleteIndex !== null) {
            saveFamly(selectedDeleteIndex);
            setSelectedDeleteIndex(null);
            setDeleteOpen(false);
        }
    };

    const cancelModal = () => {
        setDeleteOpen(false);
        setSelectedDeleteIndex(null);
    };


    const hospitalName= (val)=> {
        var hosName = "";
        switch (val){
            case "011":
            hosName = "여의도성모병원";
            break;
            case "012":
            hosName ="서울성모병원";
            break;
            case "013":
            hosName ="의정부성모병원";
            break;
            case "014":
            hosName ="부천성모병원";
            break;
            case "015":
            hosName ="은평성모병원";
            break;
            case "016":
            hosName ="인천성모병원";
            break;
            case "018":
            hosName ="대전성모병원";
            break;
            default:
            hosName ="성모병원"; 
            break;
        }
        return hosName;
    }  

    return (
        <>
            <HeadSub title="가족・보호자 설정" hospitalName={hospitalName(hsptlCd)} />

            <div id="sub-content" data-type="b">
                <div className="inner-wrap">
                    <span className={style['reference-txt']}>
                        환자 본인과 연락이 닿지 않는 경우 또는 응급 상황 발생 시 의료진이 등록된 가족·보호자 정보를 활용 할 수 있습니다.
                    </span>

                    {famlyList.length === 0 ? (
                        <div className='animation-3'>
                            <div className={style['no-data-box']}>
                                <p>등록된 가족·보호자가 없습니다.</p>
                                <button
                                    className="btn"
                                    data-btn-size="smd"
                                    data-btn-type="fill-main"
                                    data-btn-icon="arrow"
                                    data-btn-width="auto"
                                    onClick={() =>
                                        navigate(URL.HOSPITAL_PARENTALREGISTER, {
                                            state: {
                                                hsptlCd: hsptlCd
                                            }
                                        })
                                    }
                                >
                                    <span>가족·보호자 등록하기</span>
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className={style['data-list-box']}>
                            <ul>
                                {famlyList.map((item, index) => (
                                    <li key={index} className='animation-2'>
                                        <div className={style['top-box']}>
                                            <span>{item.famlyTyNm}</span>
                                            <button
                                                className={style['del-btn']}
                                                onClick={() => {
                                                    //saveFamly(item.id)
                                                    setSelectedDeleteIndex(item.id); 
                                                    setDeleteOpen(true);
                                                }}
                                            ></button>
                                        </div>
                                        <p>{item.famlyNm}</p>
                                        <span>{item.famlyMblNo}</span>
                                    </li>
                                ))}
                            </ul>

                            <div className="bottom-fixed-box">
                                <div className="inner-box" data-bg-color="transparent">
                                    <div className={style['btn-box']}>
                                        <button
                                            className={style['regist-btn']}
                                            onClick={() =>
                                                navigate(
                                                    URL.HOSPITAL_PARENTALREGISTER, {
                                                        state: {
                                                            hsptlCd: hsptlCd
                                                        }
                                                    }
                                                )
                                            }
                                        >
                                            <span>등록하기</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Modal isOpen={deleteOpen} setIsOpen={setDeleteOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> 삭제하시겠어요?</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box"> 
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={cancelModal}>
                                <span>아니오</span>
                            </button>
                            <button
                                className="btn"
                                data-btn-type="fill-main"
                                data-btn-size="md"
                                onClick={confirmDelete}
                            >
                                <span>네</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ParentalSettings;
